import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {IconButton} from '@mui/material';
import PropTypes from 'prop-types';

const ArrowButton = ({direction = 'left', onClick}) => {
  const isLeft = direction === 'left';

  const arrowStyle = {
    fontSize: 13,
    color: 'white !important'
  };

  return (
    <IconButton
      size="small"
      onClick={onClick}
      aria-label={isLeft ? 'scroll-left' : 'scroll-right'}
      sx={{
        color: 'white',
        padding: 0.5
      }}
    >
      {isLeft ? <ArrowBackIosNewIcon sx={arrowStyle} /> : <ArrowForwardIosIcon sx={arrowStyle} />}
    </IconButton>
  );
};

ArrowButton.propTypes = {
  direction: PropTypes.string,
  onClick: PropTypes.func
};

export default ArrowButton;
